export function refreshCart(data = '', {
    callback = '',
    callback_params = {},
    error_callback = '',
    error_callback_params = {}
}) {
    const mini_cart = document.querySelector('.cart-item'),
        cart_count = mini_cart && mini_cart.querySelector('.count'),
        cart_modal = document.querySelector('#mini-cart'),
        cart_modal_content = cart_modal && cart_modal.querySelector('.mini-cart-wrapper');

    const language = document.documentElement.lang.split('-')[0];

    fetch(`${language !== 'sr' ? `/${language}` : ''}/wp-json/custom/add-to-cart`, {
        method: 'post',
        body: data
    })
        .then(res => res.json())
        .then(json => {

            // Insert data
            cart_count && (cart_count.textContent = `${json.count}`);

            console.log(cart_count);

            if (cart_modal_content) {
                cart_modal_content.innerHTML = json.layout;
            }

            if (callback && callback instanceof Function) {
                callback(callback_params);
            }
        })
        .catch(err => {
            // console.error(err);

            if (error_callback && error_callback instanceof Function) {
                error_callback(error_callback_params);
            }
        });
}



// WEBPACK FOOTER //
// ./scripts/modules/refreshCart.js